export var defaultLocales = {
    CONTROLS: {
        SOLID: 'Solid',
        GRADIENT: 'Gradient',
    },
};
export var fakePresets = [
    'rgba(0,0,0,1)',
    'rgba(128,128,128, 1)',
    'rgba(192,192,192, 1)',
    'rgba(255,255,255, 1)',
    'rgba(0,0,128,1)',
    'rgba(0,0,255,1)',
    'rgba(0,255,255, 1)',
    'rgba(0,128,0,1)',
    'rgba(128,128,0, 1)',
    'rgba(0,128,128,1)',
    'rgba(0,255,0, 1)',
    'rgba(128,0,0, 1)',
    'rgba(128,0,128, 1)',
    'rgba(175, 51, 242, 1)',
    'rgba(255,0,255, 1)',
    'rgba(255,0,0, 1)',
    'rgba(240, 103, 46, 1)',
    'rgba(255,255,0, 1)',
];
